import React from 'react';

import LazyImage from '@components/LazyImage';
import { Env } from '@contexts/AppContext';
import { getImgxSrc } from '@utils/images';

export interface PartnerOfferingProps {
  description: string;
  env: Env;
  imageSrc: string;
  imageAltText: string;
  shouldHaveBoxShadow: boolean;
  title: string;
}

const PartnerOffering = ({
  env,
  description,
  imageSrc,
  imageAltText,
  shouldHaveBoxShadow = true,
  title,
}: PartnerOfferingProps): JSX.Element => (
  <figure className="mx-0 mb-0 mt-64 first-of-type:mt-32 sm:first-of-type:mt-48 md:mt-96 md:flex md:gap-x-[77px] md:even:flex-row-reverse">
    <figcaption className="md:max-w-[450px]">
      <dl className="m-0 text-black">
        <dt className="font-suisse-screen text-headline-alt-sm">{title}</dt>
        <dd className="ml-0 mt-16 font-suisse-neue text-paragraph">{description}</dd>
      </dl>
    </figcaption>
    <LazyImage
      alt={imageAltText}
      className={`w-full ${
        shouldHaveBoxShadow ? 'shadow-[0_0_20px_rgba(0,0,0,0.1)]' : 'shadow-none'
      }`}
      sizes="(min-width: 1200px) 512px, (min-width: 768px) 400px, 320px"
      src={getImgxSrc({
        path: `${imageSrc}?auto=compress`,
        isDevDependence: true,
        envContext: env,
      })}
      wrapperClassName="mt-16 sm:mt-24 pr-36 max-w-[400px] lg:max-w-[512px] md:mt-0 md:pr-0 aspect-[182/71]"
    />
  </figure>
);

export default PartnerOffering;
